import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChartModule, HighchartsStatic } from '@stackline/angular-highcharts';

import { AppComponent } from './app.component';

declare var require: any;

const Highcharts = require('highcharts');
const HighchartsMore = require('highcharts/highcharts-more');
const Highcharts3d = require('highcharts/highcharts-3d');
const Heatmap = require('highcharts/modules/heatmap');
const Treemap = require('highcharts/modules/treemap');
const Funnel = require('highcharts/modules/funnel');
const SolidGauge = require('highcharts/modules/solid-gauge');
const Stock = require('highcharts/modules/stock');
const MapModule = require('highcharts/modules/map');
const Drilldown = require('highcharts/modules/drilldown');
const NoData = require('highcharts/modules/no-data-to-display');

export function highchartsFactory() {
  HighchartsMore(Highcharts);
  Highcharts3d(Highcharts);
  Heatmap(Highcharts);
  Treemap(Highcharts);
  Funnel(Highcharts);
  SolidGauge(Highcharts);
  Stock(Highcharts);
  MapModule(Highcharts);
  Drilldown(Highcharts);
  NoData(Highcharts);
  return Highcharts;
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ChartModule
  ],
  providers: [
    { provide: HighchartsStatic, useFactory: highchartsFactory }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
